<script>
    import ReportsService from "../../services/reports.service";
    import { onMount } from 'svelte';

    let jobRoles;
    onMount(() => {
        loadData();
    });

    async function loadData() {
        const url = '/hr/job_roles';
        let result = null;
        try {
            result = await ReportsService.load(url);
        } catch (e) {
            console.log('Error', e);
        }

        if (result && result.data) jobRoles = result.data;
    }
</script>
<div class="modal fade" id="jobRolesModal" tabindex="-1" role="dialog" aria-labelledby="editSection" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="editSectionLabel">
                        Job roles
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    {#if jobRoles}
                        <table class="table container-fluid">
                            <thead>
                                <tr class="bg-dark text-light">
                                    <th class="text-center">Job Role Name</th>
                                    <th class="text-center">Role Examples</th>
                                    <th class="text-center">Description of Responsibilities</th>
                                </tr>
                            </thead>
                            <tbody>
                                {#each jobRoles as role}
                                    <tr>
                                        <td>{ role.job_role_name }</td>
                                        <td>{ role.role_examples }</td>
                                        <td>{ role.description }</td>
                                    </tr>
                                {/each}
                            </tbody>
                        </table>
                    {/if}
                </div>
            </div>
        </div>
    </div>
